/* eslint-disable no-console */
// MVP: thin console wrapper. Post-MVP: swap this file to OTel browser SDK / App Insights / Datadog RUM.
export const logger = {
  info: (msg: string, ctx?: Record<string, unknown>): void => {
    console.info(msg, ctx);
  },
  warn: (msg: string, ctx?: Record<string, unknown>): void => {
    console.warn(msg, ctx);
  },
  error: (msg: string, err?: unknown, ctx?: Record<string, unknown>): void => {
    console.error(msg, err, ctx);
  },
  debug: (msg: string, ctx?: Record<string, unknown>): void => {
    console.debug(msg, ctx);
  },
  pageView: (page: string): void => {
    console.info('[page-view]', page);
  },
  event: (name: string, props?: Record<string, unknown>): void => {
    console.info('[event]', name, props);
  },
};
